import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import * as colors from "@faire/design-tokens/index";
// eslint-disable-next-line import/no-unassigned-import
import "../../__generated__/variables.scss";
export var buildColorDesignTokens = function() {
    return Object.entries(colors).flatMap(function(param) {
        var _param = _sliced_to_array(param, 2), paletteKey = _param[0], paletteValue = _param[1];
        return Object.entries(paletteValue).flatMap(function(param) {
            var _param = _sliced_to_array(param, 2), styleKey = _param[0], styleValue = _param[1];
            return Object.entries(styleValue).map(function(param) {
                var _param = _sliced_to_array(param, 2), colorKey = _param[0], colorValue = _param[1];
                return {
                    name: "".concat(paletteKey, ".").concat(styleKey, ".").concat(colorKey),
                    value: "var(--color-".concat(paletteKey, "-").concat(styleKey, "-").concat(colorKey, ", ").concat(colorValue, ")")
                };
            });
        });
    });
};
